import './DroletQuickCart.scss';

import React, { useEffect, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import {
    useCartContent,
    useCartContext,
} from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/cart';

import { Button } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import { CSSTransition } from 'react-transition-group';
import CartItem from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Cart/CartItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LocalePrice from '@progymedia/gatsby-theme-boutik-ecommerce/src/utils/LocalePrice';
import { QuickCartIcon } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Cart/QuickCart';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

function _QuickCart() {
    const [loading, setLoading] = useState(false);
    const { isQuickCartVisible, setQuickCartVisible, isQuickCartLoading } =
        useCartContext();
    const [cart] = useCartContent();
    const { currentLocale, navigateTranslated } = usePageLocalization();
    const { t } = useTranslation('layout');

    const { quickCartCMS } = useStaticQuery(
        graphql`
            query {
                quickCartCMS: allProductsJson(
                    filter: { code: { eq: "drolet_panier-rapide" } }
                ) {
                    nodes {
                        code
                        attributes {
                            content {
                                valuesMarkdownRemark {
                                    en_US
                                    fr_CA
                                    en_CA
                                }
                            }
                        }
                    }
                }
            }
        `
    );

    const cartHeaderMessage =
        quickCartCMS?.nodes[0]?.attributes?.content
            ?.valuesMarkdownRemark?.[0]?.[currentLocale];

    useEffect(() => {
        if (isQuickCartVisible) {
            document.documentElement.style.overflow = 'hidden';
        } else {
            document.documentElement.style.overflow = '';
        }
    }, [isQuickCartVisible]);

    useEffect(() => {
        setLoading(isQuickCartLoading);
    }, [isQuickCartLoading]);

    const navigateCloseCart = (to: string) => {
        setQuickCartVisible(false);
        navigateTranslated(to);
    };

    return (
        <>
            <CSSTransition
                in={isQuickCartVisible}
                timeout={300}
                classNames='pageOverlay'
                unmountOnExit
            >
                <div
                    className='pageOverlay'
                    onClick={() => setQuickCartVisible(false)}
                ></div>
            </CSSTransition>

            <CSSTransition
                in={isQuickCartVisible}
                timeout={300}
                classNames='cartPopupMenu'
                unmountOnExit
            >
                <div key='cartPopupMenu' className={`cartPopupMenu cartSide`}>
                    {
                        // basic loading overlay
                        loading && (
                            <div className='overlay cart-loading'>
                                <div className='loader'>{t('loading')}...</div>
                            </div>
                        )
                    }
                    <div className='qCartHeader'>
                        {/* maybe: pourrait aussi afficher des messages promo/importants ?  ex.: x$ avant shipping gratuit */}
                        <p className={`q-cart-title`}>
                            {t('boutik:quick-cart.title')}
                        </p>

                        <Button onClick={() => setQuickCartVisible(false)}>
                            <FontAwesomeIcon icon={faArrowRight} />
                            {/*  <Icon
                                d='M 38.035156 13.988281 C 37.628906 13.980469 37.257813 14.222656 37.09375 14.59375 C 36.933594 14.96875 37.015625 15.402344 37.300781 15.691406 L 45.277344 24 L 2.023438 24 C 1.664063 23.996094 1.328125 24.183594 1.148438 24.496094 C 0.964844 24.808594 0.964844 25.191406 1.148438 25.503906 C 1.328125 25.816406 1.664063 26.003906 2.023438 26 L 45.277344 26 L 37.300781 34.308594 C 36.917969 34.707031 36.933594 35.339844 37.332031 35.722656 C 37.730469 36.105469 38.363281 36.09375 38.746094 35.691406 L 49.011719 25 L 38.746094 14.308594 C 38.5625 14.109375 38.304688 13.996094 38.035156 13.988281 Z'
                                viewbox='0 0 50 50'
                                size='25'
                            /> */}
                        </Button>
                    </div>

                    <div
                        className='qCartHeaderMessage'
                        dangerouslySetInnerHTML={{
                            __html: cartHeaderMessage,
                        }}
                    />

                    <div className='q-cart-content'>
                        {cart?.items?.length ? (
                            // List Cart Items
                            cart.items.map((item: any) => {
                                return (
                                    <CartItem
                                        item={item}
                                        setLoading={setLoading}
                                        key={item!.id}
                                        className={'list'}
                                    />
                                );
                            })
                        ) : (
                            // Empty Cart Notice
                            <div className='cart-empty'>
                                <p>{t('boutik:quick-cart.empty')}</p>
                            </div>
                        )}
                    </div>
                    {cart?.total_quantity ? (
                        <div className='q-cart-footer'>
                            <table className='cartPopupMenuTotal'>
                                <tbody>
                                    <tr>
                                        <th>
                                            {t('boutik:quick-cart.subtotal')}
                                        </th>
                                        <td>
                                            {LocalePrice(
                                                currentLocale,
                                                cart.prices!
                                                    .subtotal_excluding_tax!
                                                    .value
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <Button
                                className='qc-checkout'
                                onClick={() => navigateCloseCart('/mycart/')}
                                label={t('boutik:quick-cart.view-cart')}
                            />
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            </CSSTransition>
        </>
    );
}

export { _QuickCart as QuickCart, QuickCartIcon };
